import { useState, useEffect } from 'react';
import { isBusinessHours } from '../lib/utils';

interface UseAfterHoursReturn {
  isAfterHours: boolean;
  showModal: boolean;
  dismissModal: () => void;
}

export function useAfterHours(): UseAfterHoursReturn {
  const [isAfterHours, setIsAfterHours] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const afterHours = !isBusinessHours();
    setIsAfterHours(afterHours);

    if (afterHours && !dismissed) {
      const sessionDismissed = sessionStorage.getItem('afterHoursModalDismissed');
      if (!sessionDismissed) {
        setShowModal(true);
      }
    }
  }, [dismissed]);

  const dismissModal = () => {
    setShowModal(false);
    setDismissed(true);
    sessionStorage.setItem('afterHoursModalDismissed', 'true');
  };

  return { isAfterHours, showModal, dismissModal };
}
